import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MobileProjectsStateService {
  readonly expandedProjectIds = new Set<string>();
  readonly expandedExperimentKeys = new Set<string>();
  selectedBatchId: string | null = null;
  searchTerm = '';
  hasSavedExpansionState = false;

  saveExpansionState(projectIds: Set<string>, experimentKeys: Set<string>): void {
    this.expandedProjectIds.clear();
    projectIds.forEach((id) => this.expandedProjectIds.add(id));
    this.expandedExperimentKeys.clear();
    experimentKeys.forEach((key) => this.expandedExperimentKeys.add(key));
    this.hasSavedExpansionState = true;
  }
}
